import { Flex, Stack } from '@mantine/core';
import { useParams } from 'react-router';
import { useEpic } from '../../../api/tasks-client/tasks-client.hooks';
import { useTranslation } from 'react-i18next';
import { OverviewCard } from '../../../components/overview-card/overview-card';
import { ProgressBarCard } from '../../../components/overview-card/progress-bar-card';
import { useThroughputTabStore } from '../../../store/strategy-store/strategy-store';
import { graphCambridgeBlue, skyDark } from '../../../styles/design-tokens';
import { H3, Text } from '../../../ui-library/typography/typography';
import { Metric } from '../strategy.type';

type Props = {
  toggleMetric?: boolean;
};

export const EpicDetailsOverview = ({ toggleMetric = false }: Props) => {
  const i18n = useTranslation();
  const { id } = useParams();
  const { epic } = useEpic(id);
  const metric = useThroughputTabStore((state) => state.metric);

  if (!epic) {
    return null;
  }

  return (
    <Flex direction="row" gap={24}>
      <ProgressBarCard
        title={i18n.t('strategy.initiative_performance.epic_completion')}
        icon="check_circle"
        value={epic.percent_progress || 0}
        color={graphCambridgeBlue}
      />
      <OverviewCard
        title={`${i18n.t('strategy.epics.due_date')} Changes`}
        icon="date_range"
        content={
          <Stack justify="center" align="center" gap={0} mt={10}>
            <H3>{epic.n_due_date_changes || 0}</H3>
            <Text size="tiny" lineHeight="tight" color={skyDark}>
              Changes
            </Text>
          </Stack>
        }
      />
      {!toggleMetric || metric === Metric.Tasks ? (
        <>
          <OverviewCard
            title={i18n.t('strategy.initiative_performance.completed_tasks')}
            icon="check"
            content={
              <Stack justify="center" align="center" gap={0} mt={10}>
                <H3>{epic.subtasks_completed_count || 0}</H3>
                <Text size="tiny" lineHeight="tight" color={skyDark}>
                  {i18n.t('common.work_units')}
                </Text>
              </Stack>
            }
          />
          <OverviewCard
            title={i18n.t('strategy.initiative_performance.chart_labels.total_tasks')}
            icon="list_alt"
            content={
              <Stack justify="center" align="center" gap={0} mt={10}>
                <H3>{epic.subtasks_count || 0}</H3>
                <Text size="tiny" lineHeight="tight" color={skyDark}>
                  {i18n.t('common.work_units')}
                </Text>
              </Stack>
            }
          />
        </>
      ) : (
        <>
          <OverviewCard
            title={i18n.t('strategy.initiative_performance.chart_labels.completed_points')}
            icon="check"
            content={
              <Stack justify="center" align="center" gap={0} mt={10}>
                <H3>{epic.subtasks_completed_points || 0}</H3>
                <Text size="tiny" lineHeight="tight" color={skyDark}>
                  {i18n.t('common.estimation')}
                </Text>
              </Stack>
            }
          />
          <OverviewCard
            title={i18n.t('strategy.initiative_performance.chart_labels.total_points')}
            icon="list_alt"
            content={
              <Stack justify="center" align="center" gap={0} mt={10}>
                <H3>{epic.subtasks_total_points || 0}</H3>
                <Text size="tiny" lineHeight="tight" color={skyDark}>
                  {i18n.t('common.estimation')}
                </Text>
              </Stack>
            }
          />
        </>
      )}
    </Flex>
  );
};
